import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import SearchIcon from "@mui/icons-material/Search";
import TabPanel from "../../../lms/component/tabPanel/tabPanel";
import Popper from "@mui/material/Popper";
import LmsFilterList from "../../../../library/custom/lmsFilterList/lmsFilterList";
import { useLocation, useNavigate } from "react-router-dom";
import { COURSESDETAIL } from "../../../../constant/routeContant";
import {
  ORG_ID,
  LOGIN_ORG_ID,
  USER_ID,
  HBNEXT_ORG_ID,
  ROW_PER_PAGE_SIZE,
  PAGE_SIZE,
} from "../../../../constant/constant";
import { TableLoader } from "../../../../library/common/Loader";
import NORow from "../../../../library/custom/noRow/noRow";
import { useDispatch } from "react-redux";
import * as lmsUserAction from "../../../../redux/actions/lmsUserAction";
import * as lmsAction from "../../../../redux/actions/lmsAction";
import FilterButton from "../../../../library/custom/filterButton/filterButton";
import downloadIcon from "../../../../assets/downloadIcon.svg";
import { InactiveClient, getFormatedDate } from "../../../../utils/helper";
import GridTable from "../../../../library/custom/gridTable/GridTable";
const SafetyLogCourseList = ({
  coursesUserListData,
  getCoursesUserListData,
  categoryUserListData,
  isLoading,
  isShow,
  isProfile = false,
  isSafetyLog = false,
  usersId,
  setcourseid,
  courseid,
  setisstart,
  isstart,
  postunEnrollCourse,
  showDownloadButton = false,
  isAllTab = false,
  getategoryListData,
  users,
}) => {
  const [value, setValue] = useState(0);
  const [placement, setPlacement] = useState();
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const dispatch = useDispatch();
  const [selectedValue, setSelectedValue] = useState();
  const [isTableLoading, setisTableLoading] = useState(false);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [activeInActive, setActiveInActive] = useState({
    ACTIVE: false,
    INACTIVE: false,
  });
  const location = useLocation();

  const handleActiveInActiveChange = (event) => {
    const { value } = event.target;
    setActiveInActive((prevState) => {
      if (!prevState) return { ACTIVE: false, INACTIVE: false };
      const newState = {
        ...prevState,
        [value]: !prevState[value],
      };
      let status = "";
      if (newState.ACTIVE && !newState.INACTIVE) {
        status = true;
      } else if (!newState.ACTIVE && newState.INACTIVE) {
        status = false;
      }
      if (!newState.ACTIVE && !newState.INACTIVE) {
        dispatch(lmsAction.clearCategoryList());
      } else {
        const data = {
          pageNumber: 1,
          isGlobal: "",
          status: status,
        };
        getategoryListData(data);
      }

      return newState;
    });
  };

  const handleautoSearch = (event) => {
    let searchText = "";
    if (event.target.value) {
      searchText = event.target.value;
    }
    setSearch(searchText);
    const data = {
      pageNumber: 1,
      pageSize: pageSize,
      search: searchText ? searchText : "",
      catIds: selectedValue ? selectedValue : "",
      statusId: value === 0 ? 2 : value === 2 ? "" : 1,
      userId: isSafetyLog && usersId ? parseInt(usersId) : parseInt(USER_ID()),
      orgId: isProfile ? LOGIN_ORG_ID() : ORG_ID(),
      isSendMail: false,
    };
    setPage(0);
    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
    getCoursesUserListData(data);
  };

  const handlePagignation = (newPage) => {
    setPage(newPage);
    getCoursesUserListData({
      pageNumber: newPage + 1,
      pageSize: pageSize,
      search: search ? search : "",
      catIds: selectedValue ? selectedValue : "",
      statusId: value === 0 ? 2 : value === 2 ? "" : 1,
      userId: isSafetyLog && usersId ? parseInt(usersId) : parseInt(USER_ID()),
      orgId: isProfile ? LOGIN_ORG_ID() : ORG_ID(),
      isSendMail: false,
    });
  };

  const handlePageSizeChange = (newPazeSize) => {
    setPageSize(newPazeSize);
    getCoursesUserListData({
      pageNumber: page,
      pageSize: newPazeSize,
      search: search ? search : "",
      catIds: selectedValue ? selectedValue : "",
      statusId: value === 0 ? 2 : value === 2 ? "" : 1,
      userId: isSafetyLog && usersId ? parseInt(usersId) : parseInt(USER_ID()),
      orgId: isProfile ? LOGIN_ORG_ID() : ORG_ID(),
      isSendMail: false,
    });
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (!users) return;
    setPage(0);
    getCoursesUserListData({
      pageNumber: 1,
      pageSize: pageSize,
      search: search ? search : "",
      catIds: selectedValue ? selectedValue : "",
      statusId: newValue === 0 ? 2 : newValue === 2 ? "" : 1,
      userId: isSafetyLog && usersId ? parseInt(usersId) : parseInt(USER_ID()),
      orgId: isProfile ? LOGIN_ORG_ID() : ORG_ID(),
      isSendMail: false,
    });
  };

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleFilterClick = (newPlacement) => (event) => {
    setAnchorEl(event.currentTarget);
    setOpen((prev) => placement !== newPlacement || !prev);
    setPlacement(newPlacement);
  };

  const id = open ? "simple-popper" : undefined;

  const navigate = useNavigate();

  const handleViewOnClick = (courseId, status, statusId) => {
    setcourseid(courseId);

    if (statusId === 3) {
      if (InactiveClient()) return;
      const data = {
        createdBy: parseInt(USER_ID()),
        userType: 2,
        courseId: courseId,
        userOrGroupId: parseInt(USER_ID()),
        orgId: parseInt(ORG_ID()),
      };

      dispatch(lmsAction.assignCourse(data));
    } else if (statusId === 2) {
      if (InactiveClient()) return;
      setisstart(true);
      const data = {
        courseId: courseId,
        userId:
          isSafetyLog && usersId ? parseInt(usersId) : parseInt(USER_ID()),
        orgId: parseInt(ORG_ID()),
      };

      dispatch(lmsUserAction.startCourse(data));
    } else {
      navigate(COURSESDETAIL, {
        state: { courseId: courseId, courseDetailBackPath: location?.pathname },
      });
    }

    setTimeout(() => {
      const data1 = {
        pageNumber: page,
        pageSize: pageSize,
        search: search ? search : "",
        catIds: selectedValue ? selectedValue : "",
        statusId: value === 0 ? 2 : value === 2 ? "" : 1,
        userId:
          isSafetyLog && usersId ? parseInt(usersId) : parseInt(USER_ID()),
        orgId: isProfile ? LOGIN_ORG_ID() : parseInt(ORG_ID()),
        isSendMail: false,
      };
      getCoursesUserListData(data1);
    }, 2000);
  };

  const handleClose = () => {
    setAnchorEl(null);
    window.close();
  };

  const handleSearch = (data) => {
    setAnchorEl(null);
    getCoursesUserListData(data);
    setOpen(false);
  };
  const viewUnEnrollOnClick = (courseId, status, statusId) => {
    if (InactiveClient()) return;
    const DataUnEnrollCourse = {
      courseId: courseId,
      userId: isSafetyLog && usersId ? parseInt(usersId) : parseInt(USER_ID()),
      modifiedBy:
        isSafetyLog && usersId ? parseInt(usersId) : parseInt(USER_ID()),
    };

    postunEnrollCourse(DataUnEnrollCourse);

    setTimeout(() => {
      const data1 = {
        pageNumber: page,
        pageSize: pageSize,
        search: search ? search : "",
        catIds: selectedValue ? selectedValue : "",
        statusId: value === 0 ? 2 : value === 2 ? "" : 1,
        userId:
          isSafetyLog && usersId ? parseInt(usersId) : parseInt(USER_ID()),
        orgId: isProfile ? LOGIN_ORG_ID() : parseInt(ORG_ID()),
        isSendMail: false,
      };
      getCoursesUserListData(data1);
    }, 2000);
  };

  const assignedColumns = [
    { field: "course", headerName: "Course Name", flex: 3 },
    { field: "category", headerName: "Category", flex: 4 },
    {
      field: "assignedOn",
      headerName: "Date Assigned",
      flex: 3,
      renderCell: (cellValues) => {
        const formattedDate = cellValues?.row?.assignedOn
          ? getFormatedDate(cellValues?.row?.assignedOn)
          : " ";
        return <>{formattedDate}</>;
      },
    },
    {
      field: "isGlobal",
      headerName: "Provider",
      type: "text",
      minWidth: 55,
      flex: 2,
      cellClassName: "completed-byuser--cell",
      renderCell: (cellValues) => {
        const isGlobal = cellValues.row.isGlobal;
        if (
          parseInt(LOGIN_ORG_ID()) === parseInt(HBNEXT_ORG_ID) &&
          parseInt(ORG_ID()) === parseInt(HBNEXT_ORG_ID)
        ) {
          return <>{isGlobal ? "Global" : "Local"}</>;
        } else if (
          cellValues?.row?.isCloneOf === true &&
          cellValues?.row?.isGlobal === false
        ) {
          return <>{"Clone"}</>;
        } else {
          return <>{isGlobal ? "HB NEXT" : "You"}</>;
        }
      },
    },
    {
      field: "",
      width: 80,
      sortable: false,
      disableClickEventBubbling: true,
    },
  ];

  const completeColumns = [
    { field: "course", headerName: "Course Name", flex: 3 },
    { field: "category", headerName: "Category", flex: 4 },
    {
      field: "completedOn",
      headerName: "Date Completed ",
      flex: 3,
      renderCell: (cellValues) => {
        const formattedDate = cellValues?.row?.completedOn
          ? getFormatedDate(cellValues?.row?.completedOn)
          : " ";
        return <>{formattedDate}</>;
      },
    },
    {
      field: "isGlobal",
      headerName: "Provider",
      type: "text",
      minWidth: 55,
      flex: 2,
      cellClassName: "completed-byuser--cell",
      renderCell: (cellValues) => {
        const isGlobal = cellValues.row.isGlobal;
        if (
          parseInt(LOGIN_ORG_ID()) === parseInt(HBNEXT_ORG_ID) &&
          parseInt(ORG_ID()) === parseInt(HBNEXT_ORG_ID)
        ) {
          return <>{isGlobal ? "Global" : "Local"}</>;
        } else if (
          cellValues?.row?.isCloneOf === true &&
          cellValues?.row?.isGlobal === false
        ) {
          return <>{"Clone"}</>;
        } else {
          return <>{isGlobal ? "HB NEXT" : "You"}</>;
        }
      },
    },
    {
      field: "",
      width: 80,
      sortable: false,
      disableClickEventBubbling: true,
    },
  ];
  const onChangeCategoryType = (item) => {
    setSelectedValue(item);
  };

  const noRecourdCount = coursesUserListData?.noOfRecords;
  const handleClick = () => {};

  const handleClear = (item) => {
    setSelectedValue("");
    setSearch("");
    setPage(0);
    getCoursesUserListData({
      pageNumber: 1,
      pageSize: pageSize,
      search: "",
      // catIds: selectedValue ? selectedValue : "",
      catIds: "",
      statusId: value === 0 ? 2 : value === 2 ? "" : 1,
      userId: isSafetyLog && usersId ? parseInt(usersId) : parseInt(USER_ID()),
      orgId: isProfile ? LOGIN_ORG_ID() : ORG_ID(),
      isSendMail: false,
    });
    setAnchorEl(null);
    setOpen(false);
    setOpen(false);

    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
  };
  const handlesendEmail = () => {
    getCoursesUserListData({
      pageNumber: page,
      pageSize: pageSize,
      search: search ? search : "",
      catIds: selectedValue ? selectedValue : "",
      statusId:
        !isProfile && isSafetyLog === false
          ? value === 0
            ? 2
            : value === 2
            ? ""
            : 1
          : "",
      userId: isSafetyLog && usersId ? parseInt(usersId) : parseInt(USER_ID()),
      orgId: isProfile ? LOGIN_ORG_ID() : ORG_ID(),
      isSendMail: true,
    });
  };

  return (
    <>
      <div className="lessonsList noIn">
        {isShow ? (
          <Grid container className="tabuserlmstab">
            <Grid lg={7} xs={12}>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
                // variant="scrollable"
                // scrollButtons="auto"
              >
                <Tab
                  className="tabcustom"
                  icon={
                    value === 0 ? (
                      <div className="totalV">
                        {value === 0 ? noRecourdCount : ""}
                      </div>
                    ) : (
                      ""
                    )
                  }
                  iconPosition="end"
                  label="Assigned"
                />
                {/* <Tab
                  className="tabcustom"
                  icon={
                    value === 1 ? (
                      <div className="totalV">
                        {value === 1 ? noRecourdCount : ""}
                      </div>
                    ) : (
                      ""
                    )
                  }
                  iconPosition="end"
                  label="In progress"
                /> */}
                <Tab
                  className="tabcustom"
                  icon={
                    value === 1 ? (
                      <div className="totalV">
                        {value === 1 ? noRecourdCount : ""}
                      </div>
                    ) : (
                      ""
                    )
                  }
                  iconPosition="end"
                  label="Completed"
                />
                {isAllTab && (
                  <Tab
                    className="tabcustom"
                    label="All Courses"
                    icon={
                      value === 2 ? (
                        <div className="totalV">
                          {value === 2 ? noRecourdCount : ""}
                        </div>
                      ) : (
                        ""
                      )
                    }
                    iconPosition="end"
                  />
                )}
              </Tabs>
            </Grid>
            <Grid lg={5} xs={12}>
              <div className="rightFilterlms">
                <div className="searchfilter">
                  <label htmlFor="search">
                    <span>
                      <SearchIcon />
                    </span>
                    <div className="searchfilterInput">
                      <input
                        id="search"
                        placeholder="Search"
                        type="text"
                        value={search}
                        className=""
                        onChange={handleautoSearch}
                        autoComplete="off"
                      />
                    </div>
                  </label>
                </div>
                <div
                  className="filter_btn"
                  onClick={handleFilterClick("bottom-end")}
                >
                  <FilterButton label={"Filters"} handleClick={handleClick} />
                </div>
                <Popper
                  id={id}
                  open={open}
                  anchorEl={anchorEl}
                  placement={placement}
                >
                  <LmsFilterList
                    filterType={categoryUserListData?.categoryList}
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    handleClose={handleClose}
                    handleSearch={handleSearch}
                    tabvalue={value}
                    inputsearch={search}
                    onChangeType={onChangeCategoryType}
                    handleClear={handleClear}
                    filter={{}}
                    PAGE_SIZE={PAGE_SIZE}
                    selectedValue={selectedValue}
                    isFilterTypeList={false}
                    setisTableLoading={setisTableLoading}
                    activeInActive={activeInActive}
                    setActiveInActive={setActiveInActive}
                    handleActiveInActiveChange={handleActiveInActiveChange}
                    statusCheckbox={true}
                    isSafetyLog={isSafetyLog}
                    usersId={usersId}
                  />
                </Popper>
              </div>
            </Grid>
          </Grid>
        ) : (
          ""
        )}
        {showDownloadButton ? (
          <div className="div-safety-log-filter-container">
            <div className="div-download-button-container">
              <div
                className="div-download-email-right"
                onClick={handlesendEmail}
              >
                <span>
                  <img
                    src={downloadIcon}
                    className="DownLoadLogo"
                    alt="DownLoad Logo"
                  />
                </span>
                Download Data
              </div>
            </div>
          </div>
        ) : (
          ""
        )}

        <Grid container>
          <TabPanel className="tabPanel" value={value} index={0}>
            {isTableLoading ? (
              ""
            ) : (
              <div className="desc_box row_uniq">
                <div className="table_style_ui">
                  <GridTable
                    getRowId={(r) =>
                      r.id + "|" + Date.now() + Math.floor(Math.random() * 100)
                    }
                    columns={assignedColumns}
                    rows={coursesUserListData?.courses ?? []}
                    rowCount={coursesUserListData?.noOfRecords ?? 0}
                    loading={isLoading}
                    page={page}
                    pagination
                    pageSize={pageSize}
                    rowsPerPageOptions={ROW_PER_PAGE_SIZE}
                    onPageChange={handlePagignation}
                    onPageSizeChange={handlePageSizeChange}
                    checkboxSelection={false}
                    backIconButtonProps={{ disabled: false }}
                    disableSelectionOnClick
                    components={{
                      LoadingOverlay: TableLoader,
                      NoRowsOverlay: NORow,
                    }}
                  />
                </div>
              </div>
            )}
          </TabPanel>
          <TabPanel className="tabPanel" value={value} index={1}>
            {isTableLoading ? (
              ""
            ) : (
              <div className="desc_box row_uniq">
                <div className="table_style_ui">
                  <GridTable
                    getRowId={(r) =>
                      r.id + "|" + Date.now() + Math.floor(Math.random() * 100)
                    }
                    columns={completeColumns}
                    rows={coursesUserListData?.courses ?? []}
                    rowCount={coursesUserListData?.noOfRecords ?? 0}
                    loading={isLoading}
                    components={{
                      LoadingOverlay: TableLoader,
                      NoRowsOverlay: NORow,
                    }}
                    page={page}
                    pagination
                    pageSize={pageSize}
                    rowsPerPageOptions={ROW_PER_PAGE_SIZE}
                    onPageChange={handlePagignation}
                    onPageSizeChange={handlePageSizeChange}
                  />
                </div>
              </div>
            )}
          </TabPanel>
          <TabPanel className="tabPanel" value={value} index={2}>
            {isTableLoading ? (
              ""
            ) : (
              <div className="desc_box row_uniq">
                <div className="table_style_ui">
                  <GridTable
                    getRowId={(r) =>
                      r.id + "|" + Date.now() + Math.floor(Math.random() * 100)
                    }
                    // columns={columns}
                    rows={coursesUserListData?.courses ?? []}
                    rowCount={coursesUserListData?.noOfRecords ?? 0}
                    loading={isLoading}
                    components={{
                      LoadingOverlay: TableLoader,
                      NoRowsOverlay: NORow,
                    }}
                    rowsPerPageOptions={[10]}
                    page={page}
                    pagination
                    pageSize={PAGE_SIZE}
                    onPageChange={handlePagignation}
                  />
                </div>
              </div>
            )}
          </TabPanel>
          <TabPanel className="tabPanel" value={value} index={3}>
            {isTableLoading ? (
              ""
            ) : (
              <div className="desc_box row_uniq">
                <div className="table_style_ui">
                  <GridTable
                    getRowId={(r) =>
                      r.id + "|" + Date.now() + Math.floor(Math.random() * 100)
                    }
                    // columns={columns}
                    rows={coursesUserListData?.courses ?? []}
                    rowCount={coursesUserListData?.noOfRecords ?? 0}
                    loading={isLoading}
                    components={{
                      LoadingOverlay: TableLoader,
                      NoRowsOverlay: NORow,
                    }}
                    rowsPerPageOptions={[10]}
                    page={page}
                    pagination
                    pageSize={PAGE_SIZE}
                    onPageChange={handlePagignation}
                  />
                </div>
              </div>
            )}
          </TabPanel>
        </Grid>
      </div>
    </>
  );
};

export default SafetyLogCourseList;
